import dynamic from "next/dynamic";
import UniverseParagraphConfig from "./universe-paragraph-config";
import UniverseParagraphAdvancedConfig from "./universe-paragraph-advanced-config";
const UniverseParagraphComponent = dynamic(()=>import("./universe-paragraph-component"));
export default {
    UniverseParagraphComponent,
    UniverseParagraphConfig,
    UniverseParagraphAdvancedConfig
};
